import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getBuenFinSettings } from "./buen-fin.functions";
import { buenFinDays, buenFinPhase, buenFinPreviewOrigin, DEFAULT_BUEN_FIN_SETTINGS } from "./buen-fin";
export const BUEN_FIN_PREVIEW_KEY = "mm_buen_fin_preview_date";
export function useBuenFin() {
  const [now, setNow] = useState<number | null>(null);
  useEffect(() => {
    const sync = () => {
      let simulated: string | null = null;
      try { if (buenFinPreviewOrigin(window.location.hostname)) simulated = sessionStorage.getItem(BUEN_FIN_PREVIEW_KEY); } catch { /* presentation storage unavailable */ }
      const t = simulated ? Date.parse(simulated) : NaN;
      setNow(Number.isFinite(t) ? t : Date.now());
    };
    sync(); const timer = setInterval(sync, 1000); window.addEventListener("buen-fin-preview", sync);
    return () => { clearInterval(timer); window.removeEventListener("buen-fin-preview", sync); };
  }, []);
  const phase = now == null ? "off" : buenFinPhase(now);
  const query = useQuery({ queryKey: ["buen-fin-settings"], queryFn: () => getBuenFinSettings(), enabled: phase !== "off", staleTime: 60000, retry: 1 });
  return { phase, now, days: now == null ? 0 : buenFinDays(now), settings: query.data ?? DEFAULT_BUEN_FIN_SETTINGS, ready: query.isSuccess };
}